// core/api/useTermination.ts
import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../../environment";

// Define a specific base URL for termination APIs
const TERMINATION_BASE_URL = `${API_BASE_PATH}/Termination`;

// ====== Error Extractor ======
const extractErrorMessage = (error: any) => {
  const detail = error?.response?.data?.detail;
  let details = error?.response?.data?.details;
  const message = error?.response?.data?.message;

  if (typeof details === "string") {
    details = details.replace(/^\d+\s*:\s*/, ""); // strip numeric codes
  }

  return detail || details || message;
};

export const getAllTerminations = async (token: string | null) => {
  if (!token) {
    toast.error("Authentication token is missing");
    throw new Error("Authentication token is missing");
  }

  try {
    const res = await axios.get(`${TERMINATION_BASE_URL}/get_all`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error: any) {
    const msg = extractErrorMessage(error);
    toast.error(msg);
    throw error;
  }
};

export const getTerminationById = async (
  token: string | null,
  terminationId: number
) => {
  if (!token) {
    toast.error("Authentication token is missing");
    throw new Error("Authentication token is missing");
  }

  try {
    const res = await axios.get(
      `${TERMINATION_BASE_URL}/get/${terminationId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (error: any) {
    const msg = extractErrorMessage(error);
    toast.error(msg);
    throw error;
  }
};

export const createTermination = async (token: string | null, data: any) => {
  if (!token) {
    toast.error("Authentication token is missing");
    throw new Error("Authentication token is missing");
  }

  const url = `${TERMINATION_BASE_URL}/create`;
  const formData = new URLSearchParams();
  for (const key in data) {
    formData.append(key, data[key]);
  }

  try {
    const res = await axios.post(url, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
    });
    toast.success("Termination created successfully");
    return res.data;
  } catch (error: any) {
    const msg = extractErrorMessage(error);
    toast.error(msg);
    throw error;
  }
};

export const updateTermination = async (
  token: string | null,
  terminationId: number,
  data: any
) => {
  if (!token) {
    toast.error("Authentication token is missing");
    throw new Error("Authentication token is missing");
  }

  const url = `${TERMINATION_BASE_URL}/update/${terminationId}`;
  const formData = new URLSearchParams();
  for (const key in data) {
    formData.append(key, data[key]);
  }

  try {
    const res = await axios.put(url, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
    });
    toast.success("Termination updated successfully");
    return res.data;
  } catch (error: any) {
    const msg = extractErrorMessage(error);
    toast.error(msg);
    throw error;
  }
};

export const deleteTermination = async (
  token: string | null,
  terminationId: number
) => {
  if (!token) {
    toast.error("Authentication token is missing");
    throw new Error("Authentication token is missing");
  }

  try {
    const res = await axios.delete(
      `${TERMINATION_BASE_URL}/delete/${terminationId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    toast.success("Termination deleted successfully");
    return res.data;
  } catch (error: any) {
    const msg = extractErrorMessage(error);
    toast.error(msg);
    throw error;
  }
};
